// @flow
import * as React from 'react';
import styled from 'styled-components';
import Tile, { TileBody } from 'components/Tile';
import { H3 } from 'components/Text';
import Box from 'components/Box';

const StyledTile = styled(Tile)`
  margin-bottom: 36px;
  &:not(:first-child) {
    margin: 36px 0;
  }
`;

const StyledTileBody = styled(TileBody)`
  & > *:last-child {
    margin-bottom: 0;
  }
`;

const Section = ({
  title,
  description,
  children,
  large,
  bodyProps = {},
  ...props
}: {
  title?: React.Node,
  description?: React.Node,
  children: any,
  large?: boolean,
  bodyProps?: Object
}) => (
  <StyledTile {...props}>
    <StyledTileBody
      p={large ? [48, null, 96] : [20, null, 40]}
      pt={large && [36, null, 64]}
      {...bodyProps}
    >
      {title && <H3 mb={large && !description ? 56 : undefined}>{title}</H3>}
      {description && <Box mb={large ? 56 : undefined}>{description}</Box>}
      {children}
    </StyledTileBody>
  </StyledTile>
);

export default Section;
